import { useEffect, useState } from 'react';

let epoch = 0;
const listeners = new Set<() => void>();

/** Bump after a PIN sign-in or sign-out so session-dependent hooks refetch. */
export function refreshSessionData(): void {
  epoch += 1;
  for (const listener of listeners) listener();
}

export function useSessionDataEpoch(): number {
  const [value, setValue] = useState(epoch);
  useEffect(() => {
    const listener = () => setValue(epoch);
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);
  return value;
}
